/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  ChangePasswordDto,
  EmailSignUpDto,
  RoleTypeUpdateDto,
  UserInfoDto,
  UserProfileDto,
} from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class AdminMemberService<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags AdminMemberService
   * @name WithdrawAdminMember
   * @summary Withdraw Admin Member
   * @request PUT:/v1/admin/members/{memberId}/withdraw
   * @secure
   */
  withdrawAdminMember = (memberId: number, params: RequestParams = {}) =>
    this.http.request<UserInfoDto, any>({
      path: `/v1/admin/members/${memberId}/withdraw`,
      method: 'PUT',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminMemberService
   * @name UnwithdrawAdminMember
   * @summary Unwithdraw Admin Member
   * @request PUT:/v1/admin/members/{memberId}/unwithdraw
   * @secure
   */
  unwithdrawAdminMember = (memberId: number, params: RequestParams = {}) =>
    this.http.request<UserInfoDto, any>({
      path: `/v1/admin/members/${memberId}/unwithdraw`,
      method: 'PUT',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminMemberService
   * @name GetAdminMembers
   * @summary Get Admin Members
   * @request GET:/v1/admin/members
   * @secure
   */
  getAdminMembers = (
    query?: {
      searchKeyword?: string;
      /**
       * Zero-based page index (0..N)
       * @min 0
       * @default 0
       */
      page?: number;
      /**
       * The size of the page to be returned
       * @min 1
       * @default 20
       */
      size?: number;
      /** Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported. */
      sort?: string[];
    },
    params: RequestParams = {},
  ) =>
    this.http.request<UserInfoDto[], any>({
      path: `/v1/admin/members`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * @description 관리자 이메일 계정을 생성합니다.
   *
   * @tags AdminMemberService
   * @name RegisterAdminMember
   * @summary Register Member
   * @request POST:/v1/admin/members
   * @secure
   */
  registerAdminMember = (data: EmailSignUpDto, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/admin/members`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminMemberService
   * @name SaveMemberProfile
   * @summary Save or Update Member Profile
   * @request POST:/v1/admin/members/{memberId}/profile
   * @secure
   */
  saveMemberProfile = (memberId: number, data: UserProfileDto, params: RequestParams = {}) =>
    this.http.request<UserProfileDto, any>({
      path: `/v1/admin/members/${memberId}/profile`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminMemberService
   * @name ChangePassword
   * @summary Reset Password
   * @request POST:/v1/admin/members/{memberId}/change-password
   * @secure
   */
  changePassword = (memberId: number, data: ChangePasswordDto, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/admin/members/${memberId}/change-password`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminMemberService
   * @name ChangeMemberRoleType
   * @summary Save or Update Admin Member RoleType
   * @request PATCH:/v1/admin/members/{memberId}/role-type
   * @secure
   */
  changeMemberRoleType = (memberId: number, data: RoleTypeUpdateDto, params: RequestParams = {}) =>
    this.http.request<UserProfileDto, any>({
      path: `/v1/admin/members/${memberId}/role-type`,
      method: 'PATCH',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminMemberService
   * @name GetAdminMember
   * @summary Get Member by ID
   * @request GET:/v1/admin/members/{memberId}
   * @secure
   */
  getAdminMember = (memberId: number, params: RequestParams = {}) =>
    this.http.request<UserInfoDto, any>({
      path: `/v1/admin/members/${memberId}`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
}
